import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../css/welcome.css';

const WelcomePage = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);
  const [progress, setProgress] = useState(0);

  // Get time-based greeting
  const getGreeting = () => {
    const hour = new Date().getHours();
    
    if (hour >= 6 && hour < 12) {
      return {
        main: "Good Morning!",
        sub: "Wah, thank you for choosing POSlah! Dashboard setting up already... Confirm can make power sales one! Steady Pom Pi Pi!"
      };
    } else if (hour >= 12 && hour < 18) {
      return {
        main: "Good Afternoon!",
        sub: "Thank you for choosing POSlah leh! Dashboard loading now... Ready to make shiok sales! Steady Pom Pi Pi!"
      };
    } else {
      return {
        main: "Good Evening!",
        sub: "Walao, thank you for choosing POSlah! Dashboard almost ready... Time to make good sales already! Steady Pom Pi Pi!"
      };
    }
  };

  const greeting = getGreeting();

  useEffect(() => {
    // Trigger animations
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 300);

    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          return 100;
        }
        return prev + 2;
      });
    }, 50); // 5 seconds total (100/2 * 100ms = 5000ms)

    // Navigate to dashboard after 5 seconds
    const redirectTimer = setTimeout(() => {
      navigate('/dashboard', { replace: true });
    }, 5000); // 5 seconds

    return () => {
      clearTimeout(timer);
      clearTimeout(redirectTimer);
      clearInterval(progressInterval);
    };
  }, [navigate]);

  return (
    <div className="welcome-screen">
      <div className="welcome-container-new">
        {/* Main Greeting */}
        <div className={`greeting-main ${isVisible ? 'fade-in-up' : ''}`}>
          <h1 className="main-greeting">
            {greeting.main}
          </h1>
        </div>

        {/* Sub Message */}
        <div className={`greeting-sub ${isVisible ? 'fade-in-up-delayed' : ''}`}>
          <p className="sub-message">
            {greeting.sub}
          </p>
        </div>

        {/* Progress Indicator */}
        <div className={`progress-section ${isVisible ? 'fade-in-up-more-delayed' : ''}`}>
          <div className="progress-bar-new">
            <div 
              className="progress-fill-new"
              style={{ width: `${progress}%` }}
            />
          </div>
          <div className="progress-text-new">{Math.round(progress)}%</div>
        </div>

        {/* Loading Dots */}
        <div className={`loading-dots-new ${isVisible ? 'fade-in-last' : ''}`}>
          <span className="dot-new"></span>
          <span className="dot-new"></span>
          <span className="dot-new"></span>
        </div>
      </div>

      {/* Background Animation */}
      <div className="bg-particles">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
      </div>
    </div>
  );
};

export default WelcomePage;